<template>
  <v-data-table :headers="headers" :items="items" :search="search"
 class="elevation-1" :loading="isLoading" :loading-text="$t('loadingData')">
    <template v-slot:[`item.projected_duration`]="{ item }">
      {{ setDuration(item.scheduled_start, item.scheduled_end) }}
    </template>
    <template v-slot:[`item.type_name`]="{ item }">
      <v-chip :color="item.type_color" dark>
        {{ item.type_name }}
      </v-chip>
    </template>
    <template v-slot:[`item.appointment_status_id`]="{ item }">
      <v-chip :color="setStatusColor(item.appointment_status_id)" dark>
        {{ $t(setStatusText(item.appointment_status_id)) }}
      </v-chip>
    </template>
    <template v-slot:no-data>
      {{ $t("appointmentsEmpty") }}
    </template>
  </v-data-table>
</template>
<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { calcDuration, appointmentStatusToColor, appointmentStatusToName } from "../../helpers/data";

@Component
export default class DashboardTodaysAppointmentsTable extends Vue {
  @Prop() readonly headers: any;
  @Prop() readonly items: any;
  @Prop() readonly search: string;
  @Prop() readonly isLoading: boolean;

  setStatusColor(status: string) {
    return appointmentStatusToColor(status);
  }

  setStatusText(status: string) {
    return appointmentStatusToName(status);
  }

  setDuration(start: Date, end: Date) {
    return calcDuration(start, end);
  }
}
</script>
